import React from 'react';
import { Card } from 'react-bootstrap';
import { BillingInfo } from 'models/Billing';
import { formatBillingDate, formatPlanName } from 'utils/billing';

type BillingStatusPanelProps = {
  billing: BillingInfo;
};

const BillingStatusPanel: React.FC<BillingStatusPanelProps> = ({ billing }) => {
  const planName = formatPlanName(
    billing.subscription?.plan_code || billing.current_plan_code
  );
  const portalUrl = billing.customer_portal_url;

  let statusCopy: React.ReactNode = null;

  if (billing.billing_status === 'trialing') {
    const trialEnd =
      billing.trial_ends_at || billing.subscription?.trial_end || null;
    statusCopy = (
      <>
        <strong>{planName} Trial Active</strong> — trial ends{' '}
        {formatBillingDate(trialEnd)}. Subscription begins automatically unless
        canceled.
      </>
    );
  } else if (billing.billing_status === 'active') {
    const nextBill =
      billing.subscription?.current_period_end ||
      billing.billing_activated_at ||
      null;
    statusCopy = (
      <>
        <strong>{planName} Plan Active</strong> — Next billing date:{' '}
        {formatBillingDate(nextBill)}.
      </>
    );
  } else {
    statusCopy = (
      <>
        Current billing status:{' '}
        <strong>{billing.billing_status.replace(/_/g, ' ')}</strong>
        {billing.current_plan_code
          ? ` (${formatPlanName(billing.current_plan_code)})`
          : ''}
        .
      </>
    );
  }

  return (
    <Card className="border border-200">
      <Card.Body>
        <h4 className="mb-3">Your plan</h4>
        <p className="mb-4 text-700">{statusCopy}</p>
        {portalUrl ? (
          <a
            href={portalUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary"
          >
            Manage Billing
          </a>
        ) : (
          <p className="mb-0 text-600 small">
            Billing portal is not available yet. Contact Shiplab if you need
            help managing your subscription.
          </p>
        )}
      </Card.Body>
    </Card>
  );
};

export default BillingStatusPanel;
